import { useQuery } from "@tanstack/react-query";
import { DonationKey } from "../donation-key";
import { getMyAcceptedDonation } from "@services/admin.fixransomware.com";







export function useGetMyAcceptedDonation(){

  return useQuery({
    queryKey: [DonationKey, "accepted", "latest"],
    staleTime: 1000 * 60,
    queryFn: () => getMyAcceptedDonation(),
  })
}